import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked",
  "use": "checked-usage",
  "viewBox": "0 0 11 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 11 8\" id=\"checked\"><path d=\"M9.416.263 3.647 5.836 1.582 3.843a.95.95 0 0 0-1.311 0 .87.87 0 0 0 0 1.265l2.724 2.627A.949.949 0 0 0 3.647 8a.918.918 0 0 0 .651-.265l6.428-6.202a.868.868 0 0 0 0-1.264.94.94 0 0 0-1.31-.006Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol